/**
 * Audit API – audit log reads via Cloud Functions. Super admin only.
 */

import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../firebase/config';

const functions = getFunctions(app, 'us-central1');

function call(name, data = {}) {
  const fn = httpsCallable(functions, name);
  return fn(data).then((res) => res.data);
}

/**
 * Fetch audit logs with filters and pagination.
 * @param {object} options - { dateFrom, dateTo, filterExcludeUserId, cursor, direction }
 */
export async function getAuditLogs(options = {}) {
  return call('auditGetLogs', options);
}
